import * as React from 'react';

import { NextBestAction, Interstitial } from '@origin-digital/personalisation';
import { ExperienceSelector } from '@origin-digital/features';

import { webMboxes, appMboxes } from 'src/consts';

export const PersonalisedCard: React.FunctionComponent = () => (
  <div data-id="personalised-card">
    <ExperienceSelector mbox={webMboxes.NBA_CARD_WEB}>
      {(content) => <NextBestAction content={content} />}
    </ExperienceSelector>
    <ExperienceSelector mbox={appMboxes.NBA_CARD_APP}>
      {(content) => <NextBestAction content={content} />}
    </ExperienceSelector>
    <ExperienceSelector mbox={webMboxes.INTERSTITIAL_WEB}>
      {(content) => <Interstitial content={content} />}
    </ExperienceSelector>
    <ExperienceSelector mbox={appMboxes.INTERSTITIAL_APP}>
      {(content) => <Interstitial content={content} />}
    </ExperienceSelector>
  </div>
);
